export default function() {
    const widgetName = 'cardWidgetButtons';
    const widgetOpts = cardWidgetButtonsOpts;
  
    return saffire.widgets.cardWidget($(`#${widgetName}`), {
      currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
      buyNowButton: {
        visible: false,
        text: 'BUY NOW'
      },
      cardWidgetLoaded: function(data, owl, hasData) {

        $( "#cardWidgetButtons .card-widget-item" ).each(function() {
          var title = $(this).find(".card-widget-title");
          var imageContainer = $(this).find(".image-container");
          imageContainer.before(title);
        });
        
      },
      itemsPerPanel: 1,
      hasImages: true,
      lazyLoadImages: true,
      imageIsBackground: false,
      link: [], // [], ['all'], ['image', 'title', 'description']
      maxItemsVisible: 2,
      moreButton: {
        visible: true,
        text: 'LEARN MORE'
      },
      scriptPath:  widgetOpts.scriptPath,
      showDescription: true,
      textOverImage: false
    });
  
  }